import { Plugins } from '@capacitor/core'

const { Storage } = Plugins

export const setObject = async (key, obj) => {
  await Storage.set({
    key: key,
    value: JSON.stringify(obj)
  })
}

export const getObject = async (key) => {
  const ret = await Storage.get({ key: key })
  return JSON.parse(ret.value)
}

export const setItem = async (key, value) => {
  await Storage.set({
    key: key,
    value: value
  })
}

export const getItem = async (key) => {
  const { value } = await Storage.get({ key: key })
  return value
}

export const removeItem = async (key) => {
  await Storage.remove({ key: key })
}

export const keys = async () => {
  const { keys } = await Storage.keys()
  return keys
}

export const clear = async () => {
  await Storage.clear()
}



// WEBPACK FOOTER //
// ./src/storage.js